<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "vacancyWrapper"
};
</script>

<style scoped></style>
